import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import services from '../services';
import withResponseHandling from './withResponseHandling';
import withMessage from './withMessage';
import { acPortfoliosChanged } from '../store/actions';
import usePrevious from '../hooks/usePrevious';
const PAGE_SIZE = 25;
const withPortfolios = Component => {
  function WrapComponent(props) {
    const arquivosUpdatedAt = useSelector(state => state.background.arquivos.updatedAt);
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const prevArquivosUpdateAt = usePrevious(arquivosUpdatedAt);
    const storeDispatch = useDispatch();
    const [portfolios, setPortfolios] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });
    function updateStore(pData) {
      storeDispatch(acPortfoliosChanged(pData));
    }
    const readPortfolios = useCallback((pParams = {}, pCallback) => {
      if (!portfolios.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }
      const xParams = {
        size: PAGE_SIZE,
        page: 1,
        sort: 'portfolio desc',
        ...pParams
      };
      services.portfolios.list(xParams, rRes => {
        setPortfolios(Object.values(rRes.data));
        setRowCount(rRes.pages.total_items);
        pCallback && pCallback(Object.values(rRes.data));
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {
        setIsLoading(false);
        setIsRefetching(false);
      });
    }, [portfolios.length, props]);
    const deletePortfolio = (pPortfolioId, onFinish) => {
      services.portfolios.remove(pPortfolioId, rRes => {
        props.onMessageSuccess('Portfolio excluído com sucesso');
        readPortfolios({}, updateStore);
        setRowSelection({});
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {
        onFinish && onFinish();
      });
    };
    const bulkDeletePortfolios = pRows => {
      const xPortfoliosId = pRows.map(xRow => {
        const {
          portfolio_id
        } = xRow.original;
        return portfolio_id;
      });
      xPortfoliosId.forEach(xId => {
        deletePortfolio(xId);
      });
    };
    useEffect(() => {
      const xPage = pagination.pageIndex + 1;
      readPortfolios({
        page: xPage,
        size: pagination.pageSize
      });
    }, [readPortfolios, pagination.pageIndex, pagination.pageSize, arquivosUpdatedAt, prevArquivosUpdateAt, entidadeId]);
    const xProps = {
      portfolios,
      isLoading,
      isRefetching,
      rowCount,
      rowSelection,
      pagination,
      setPagination,
      setRowSelection,
      readPortfolios,
      deletePortfolio,
      bulkDeletePortfolios
    };
    return <Component {...xProps} />;
  }
  return withMessage(withResponseHandling(WrapComponent));
};
export default withPortfolios;
